import { useTranslation, Button } from '@nextgen-web-framework/all';
import LoginWrapper from '../login-wrapper/LoginWrapper';
import { LoginButtonPropsTypes } from './types/propTypes';

const LoginButton = (options: LoginButtonPropsTypes) => {
  const t = useTranslation();
  const { title = t('identity.LoginButton.buttonLabel'), buttonWidth } = options;
  const btnProps = {
    title,
    buttonWidth,
  };
  return (
    <LoginWrapper {...options}>
      <Button data-testid="loginButton-test-id" {...btnProps} />
    </LoginWrapper>
  );
};

export default LoginButton;
